/**
 * @flow
 * @relayHash bca22a041ee7bbd317bd467ea071910d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DeliverableReview_deliverable$ref = any;
export type DeliverableReviewTabQueryVariables = {|
  id: string
|};
export type DeliverableReviewTabQueryResponse = {|
  +deliverable: ?{|
    +$fragmentRefs: DeliverableReview_deliverable$ref
  |}
|};
export type DeliverableReviewTabQuery = {|
  variables: DeliverableReviewTabQueryVariables,
  response: DeliverableReviewTabQueryResponse,
|};
*/


/*
query DeliverableReviewTabQuery(
  $id: ID!
) {
  deliverable(id: $id) {
    ...DeliverableReview_deliverable
    id
  }
}

fragment DeliverableReview_deliverable on DeliverableNode {
  id
  state
  description
  job {
    id
    name
    contractor {
      fullName
      representativeImageUrl
      id
    }
  }
  assignedStaff {
    fullName
    representativeImageUrl
    id
  }
  reviewAssetFileValidationConfig {
    reviewInterface
    fileTypes
    fileSize
  }
  reviewActive {
    id
    step {
      id
      name
    }
    reviewStepList {
      id
      name
    }
    deliverableReviewAssets {
      edges {
        node {
          id
          fileName
          fileThumbnailUrl
          storageClass
          created
          revisionNumber
          reviewInterface
          reactions {
            id
            definitionId
            name
            color
            number
            users {
              id
              fullName
              representativeImageUrl
            }
          }
          comments {
            edges {
              node {
                id
                created
                content
                extraData
                contentEditedAt
                repliedTo {
                  content
                  created
                  user {
                    fullName
                    id
                  }
                  referenceFiles {
                    id
                    title
                    description
                    fileUrl
                    reviewInterface
                  }
                }
                user {
                  id
                  fullName
                  representativeImageUrl
                }
                referenceFiles {
                  id
                  title
                  description
                  fileUrl
                  reviewInterface
                }
                reactions {
                  id
                  definitionId
                  name
                  color
                  number
                  users {
                    id
                    fullName
                    representativeImageUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "representativeImageUrl",
  "args": null,
  "storageKey": null
},
v7 = [
  (v5/*: any*/),
  (v6/*: any*/),
  (v2/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "reviewInterface",
  "args": null,
  "storageKey": null
},
v9 = [
  (v2/*: any*/),
  (v4/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "created",
  "args": null,
  "storageKey": null
},
v11 = [
  (v2/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "reactions",
  "storageKey": null,
  "args": null,
  "concreteType": "ReactionNode",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "definitionId",
      "args": null,
      "storageKey": null
    },
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "color",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "number",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "users",
      "storageKey": null,
      "args": null,
      "concreteType": "UserNode",
      "plural": true,
      "selections": (v11/*: any*/)
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "content",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "referenceFiles",
  "storageKey": null,
  "args": null,
  "concreteType": "ReferenceNode",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "fileUrl",
      "args": null,
      "storageKey": null
    },
    (v8/*: any*/)
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeliverableReviewTabQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deliverable",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DeliverableNode",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DeliverableReview_deliverable",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DeliverableReviewTabQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deliverable",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DeliverableNode",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "state",
            "args": null,
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "job",
            "storageKey": null,
            "args": null,
            "concreteType": "JobNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "contractor",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractorNode",
                "plural": false,
                "selections": (v7/*: any*/)
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "assignedStaff",
            "storageKey": null,
            "args": null,
            "concreteType": "StaffNode",
            "plural": false,
            "selections": (v7/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "reviewAssetFileValidationConfig",
            "storageKey": null,
            "args": null,
            "concreteType": "ReviewAssetFileValidationConfig",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fileTypes",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fileSize",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "reviewActive",
            "storageKey": null,
            "args": null,
            "concreteType": "DeliverableReviewNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "step",
                "storageKey": null,
                "args": null,
                "concreteType": "StepNode",
                "plural": false,
                "selections": (v9/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "reviewStepList",
                "storageKey": null,
                "args": null,
                "concreteType": "StepNode",
                "plural": true,
                "selections": (v9/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "deliverableReviewAssets",
                "storageKey": null,
                "args": null,
                "concreteType": "ReviewAssetNodeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ReviewAssetNodeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ReviewAssetNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "fileName",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "fileThumbnailUrl",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "storageClass",
                            "args": null,
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "revisionNumber",
                            "args": null,
                            "storageKey": null
                          },
                          (v8/*: any*/),
                          (v12/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "comments",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CommentNodeConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CommentNodeEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CommentNode",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v10/*: any*/),
                                      (v13/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "extraData",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "contentEditedAt",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "repliedTo",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "CommentRepliedToNode",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/),
                                          (v10/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "user",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "UserNode",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              (v2/*: any*/)
                                            ]
                                          },
                                          (v14/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "user",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "UserNode",
                                        "plural": false,
                                        "selections": (v11/*: any*/)
                                      },
                                      (v14/*: any*/),
                                      (v12/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "DeliverableReviewTabQuery",
    "id": null,
    "text": "query DeliverableReviewTabQuery(\n  $id: ID!\n) {\n  deliverable(id: $id) {\n    ...DeliverableReview_deliverable\n    id\n  }\n}\n\nfragment DeliverableReview_deliverable on DeliverableNode {\n  id\n  state\n  description\n  job {\n    id\n    name\n    contractor {\n      fullName\n      representativeImageUrl\n      id\n    }\n  }\n  assignedStaff {\n    fullName\n    representativeImageUrl\n    id\n  }\n  reviewAssetFileValidationConfig {\n    reviewInterface\n    fileTypes\n    fileSize\n  }\n  reviewActive {\n    id\n    step {\n      id\n      name\n    }\n    reviewStepList {\n      id\n      name\n    }\n    deliverableReviewAssets {\n      edges {\n        node {\n          id\n          fileName\n          fileThumbnailUrl\n          storageClass\n          created\n          revisionNumber\n          reviewInterface\n          reactions {\n            id\n            definitionId\n            name\n            color\n            number\n            users {\n              id\n              fullName\n              representativeImageUrl\n            }\n          }\n          comments {\n            edges {\n              node {\n                id\n                created\n                content\n                extraData\n                contentEditedAt\n                repliedTo {\n                  content\n                  created\n                  user {\n                    fullName\n                    id\n                  }\n                  referenceFiles {\n                    id\n                    title\n                    description\n                    fileUrl\n                    reviewInterface\n                  }\n                }\n                user {\n                  id\n                  fullName\n                  representativeImageUrl\n                }\n                referenceFiles {\n                  id\n                  title\n                  description\n                  fileUrl\n                  reviewInterface\n                }\n                reactions {\n                  id\n                  definitionId\n                  name\n                  color\n                  number\n                  users {\n                    id\n                    fullName\n                    representativeImageUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7be6887f6339a49aea3f9d27fea4ee0e';
module.exports = node;
